<template>
    <div>
        <data-grid
            name="camp-call-stats-details"
            class="camp-calls-list"
            :columns="callColumns"
            :title="title"
            ref="grid"
            :url="url"
            :hideHeader="true"
            :selectionEnabled="false"
            :beforeSetupGrid="beforeSetupGrid"
            :perPage="10"
            :sortOptions="{
                enabled: true,
                field: 'date',
                type: 'desc',
            }"
            :expandedOptions="{
                enabled: true,
                template: 'camp-call-details',
            }"
        ></data-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data: () => ({
        title: "Calls",

        userBranch: "",
        url: "",
        callColumns: [
            {
                field: "phoneLine",
                isIcon: true,
                icon: (value) => {
                    if (!value) return "";

                    switch (value) {
                        case "PARENTS LINE":
                            return "mdi-phone-incoming";
                        case "STUDENTS LINE":
                            return "mdi-phone-outgoing";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "";

                    switch (value) {
                        case "PARENTS LINE":
                            return "#007827";
                        case "STUDENTS LINE":
                            return "#27a4d9";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                sortable: true,
                label: "Student",
                field: "studentNameH",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Father Hebrew",
                field: "fatherH",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "date",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Duration",
                field: "duration",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "From",
                field: "from",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "To Number",
                field: "toNumber",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            // {
            //     sortable: false,
            //     label: "To",
            //     field: "to",
            //     hidden: false,
            //     filterOptions: {
            //         enabled: true,
            //     },
            // },
            {
                sortable: false,
                label: "Boot Number",
                field: "bootNumber",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Branch",
                field: "branch",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Phone Type",
                field: "phoneType",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Blocked",
                field: "isBlocked",
                type: "boolean",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Select",
                    filterDropdownItems: [
                        { value: true, text: "Yes" },
                        { value: false, text: "No" },
                    ],
                },
            },
            // {
            //     sortable: false,
            //     label: "Phone Line",
            //     field: "phoneLine",
            //     hidden: false,
            //     filterOptions: {
            //         enabled: true,
            //         filterDropdownItems: ['STUDENTS LINE', 'PARENTS LINE']
            //     }
            // },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.url =
                "campCalls?to=" +
                encodeURIComponent(this.row.number) +
                "&branch=&studentID=";
        },
        async onRowClicked(call) {},
    },
};
</script>
<style>
.camp-calls-list.container {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
.camp-calls-list.container.grid-list-xl .layout .flex {
    padding: 0px !important;
    padding-bottom: 10px !important;
}
.camp-calls-list .v-card__text {
    padding-top: 0px !important;
}
.camp-calls-list .grid-card {
    margin-bottom: 0px !important;
}
.camp-calls-list tr:nth-child(even) {
    background-color: #fff !important;
}
.camp-calls-list td {
    padding: 0.75em 0.75em 0.75em 0.75em !important;
    vertical-align: top !important;
    color: black !important;
    background-color: unset !important;
}
</style>
